import { css, useTheme } from '@fable/theme'
import { FlexBox } from '@fable/components'
import { ChartXAxis } from './ChartXAxis'
import { ChartYAxis } from './ChartYAxis'
import { ChartLegend } from '../../../chart_legend'
import { BarChart } from './BarChart'
import { useGoalHabits } from '../../lib/ctx'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const WeekBarChart = () => {
  const theme = useStatsTheme((s) => s.theme)
  const type = useGoalHabits((s) => s.type)
  const { colors } = useTheme()

  const getLabel = () => {
    switch (type) {
      case 'active_days':
        return 'Days'
      case 'books_finished':
        return 'Books'
      case 'pages_read':
        return 'Pages'
    }
  }

  return (
    <div
      className={css`
        padding: 10px 0 10px;
        width: 100%;
        position: relative;
      `}
    >
      <FlexBox
        className={css`
          width: 100%;
          height: 220px;
          gap: 8px;
        `}
      >
        <BarChart />
        <ChartYAxis />
      </FlexBox>
      <ChartXAxis />
      <ChartLegend
        className={css`
          padding-top: 36px;
        `}
        items={[
          {
            color: theme.colors.primary,
            label: `${getLabel()} read per week`,
          },
          {
            color: colors.uiPearl,
            label: 'Your weekly goal',
          },
        ]}
      />
    </div>
  )
}
